import ParameterValidator from '@mvps-genesis/parameter-validator';

export default class ScrollTo {

	/**
	 * Parameter Validator class object
	 *
	 * @var	{ParameterValidator} @mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * Collection of elements to trigger the scroll to functionaliy
	 *
	 * @var {HTMLCollection|NodeList}
	 */
	triggerElements;

	/**
	 * Function to run before the scroll to functionality triggers
	 *
	 * @var {Function|null}
	 */
	beforeScroll;

	/**
	 * The scroll to element
	 *
	 * {HTMLElement}
	 */
	scrollElement;

	/**
	 * Scroll into view options object
	 *
	 * @var {Object}
	 */
	scrollIntoViewOptions;

	/**
	 * Create a new ScrollTo object
	 *
	 * @param  {HTMLCollection|NodeList|String}  triggerElements        The trigger elements for the scroll to functionality. These elements will have click events attached to them that will call the beforeScroll function and then scroll to the scroll element.
	 * @param  {Function|null}	                 beforeScroll           This function will be called before scrolling so that JS methods can be used to hook into the click-event of the triggers, modify the dom (ex show a hidden target DOM element), and then scroll to the scrollTo element. Defaults to `null`.
	 * @param  {String}		                     scrollToAttribute      The scroll to data attribute on the trigger elements. Used when the scrollToSelector value is not provided or empty. Defaults to 'data-scroll-to'.
	 * @param  {String}		                     scrollToSelector       Selector to explicitly target the scroll to element. Defaults to ''.
	 * @param  {Object}		                     scrollIntoViewOptions  Object to be passed into the `Element.scrollIntoView()` function when the scroll-to is performed. Defaults to `{}`
	 */
	constructor (triggerElements, {
		beforeScroll = null,
		scrollToAttribute = 'data-scroll-to',
		scrollToSelector = '',
		scrollIntoViewOptions = {}
	} = {}) {
		this.#validator = new ParameterValidator(this);

		this.triggerElements = this.#validator.isElementList('triggerElements', triggerElements);

		this.beforeScroll = beforeScroll;
		this.scrollElement = this.#validator.isElement('scrollElement', this.#validator.isString('scrollToSelector', scrollToSelector) || this.triggerElements[0].getAttribute(this.#validator.isString('scrollToAttribute', scrollToAttribute)));
		this.scrollIntoViewOptions = this.#validator.isObject('scrollIntoViewOptions', scrollIntoViewOptions);

		this.bindEvents();
	}

	bindEvents () {
		for (const triggerElement of this.triggerElements) {
			triggerElement.addEventListener('click', (event) => this.scrollToElement(event));
		}
	}

	scrollToElement (event) {
		event.preventDefault();

		if (typeof this.beforeScroll === 'function') {
			this.beforeScroll();
		}

		this.scrollElement.scrollIntoView(this.scrollIntoViewOptions);
	}

}
